import {styled} from '@linaria/react';
import React from 'react';
import {ImageType} from '../../../types/Image';
import {Image} from '../../atoms/Image/Image';
import {Breakpoints, Ratio, Widths} from '../../atoms/Image/types';
import {UnstyledLink} from '../../atoms/UnstyledLink/UnstyledLink';

interface CardImageWithFooterProps {
  ['aria-label']: string;
  ['data-testid']?: string;
  className?: string;
  href: string;
  onClick?: VoidFunction;
  caption?: React.ReactNode;
  image: ImageType;
  imageRatio: Ratio;
  breakpoints: Breakpoints;
  footer?: React.ReactNode;
  widths?: Widths;
}

export const CardImageWithFooter: React.FC<CardImageWithFooterProps> = ({
  className,
  'data-testid': dataTestId,
  'aria-label': ariaLabel,
  href,
  onClick,
  caption,
  image,
  imageRatio,
  breakpoints,
  footer,
  widths,
}) => {
  return (
    <Wrapper
      data-testid={dataTestId}
      className={className}
      to={href}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {caption && <Caption>{caption}</Caption>}
      <StyledImage
        src={image.url}
        alt=""
        ratio={imageRatio}
        breakpoints={breakpoints}
        widths={widths}
      />

      {footer && <>{footer}</>}
    </Wrapper>
  );
};

const Wrapper = styled(UnstyledLink)`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0.5px 3px 4px 0 rgba(0, 0, 0, 0.08),
    0 1px 8px 4px rgba(0, 0, 0, 0.06);
`;

const Caption = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;

export const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: top;
  height: 100%;
`;
